module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.prompt),
      expression: "prompt"
    }],
    attrs: {
      "id": "prompt"
    }
  }, [_c('div', {
    ref: "masker",
    staticClass: "mask",
    on: {
      "click": _vm.closedMask
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.save),
      expression: "save"
    }],
    attrs: {
      "src": "http://shared.youdao.com/dict/market/oxford-activity/imgs/save.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.share),
      expression: "share"
    }],
    attrs: {
      "src": "http://shared.youdao.com/dict/market/oxford-activity/imgs/share.png",
      "alt": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e5e2edd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prompt.vue
// module id = 140
// module chunks = 1